import React, { useEffect } from "react";
import { useOrderContext } from "../../hooks/useGenerateOrder";
import { Loader2 } from "lucide-react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import {
  getCategories as onGetCategories,
  getUserByEmail as onGetUserByEmail,
  getJewelleryById as onGetJewelleryById,
  createUser,
  addAddress,
} from "slices/thunk";
import { useFormik } from "formik";
import * as Yup from "yup";

interface ProductDetailProps {
  // selectedMetal: "gold" | "rosegold" | "whitegold";
  // setSelectedMetal: (val: "gold" | "rosegold" | "whitegold") => void;
  // selectedKarat: "14k" | "18k";
  // setSelectedKarat: (val: "14k" | "18k") => void;
}

const ProductDetail: React.FC<ProductDetailProps> = () => {
  const {
    jewellery,
    categories,
    configuration,
    setConfiguration,
    isLoadingPrice,
    ringSizeOptions,
    braceletLengthOption,
    stoneSizes,
    selectedSize,
    setSelectedSize,
    handleSelectionChange,
    totalJewelleryPrice,
    user,
    generateOrderValue,
    ringSize,
    setRingSize,
    braceletLength,
    setBraceletLength,
    selectedKarat,
    selectedMetal,
    selectedType,
    setSelectedType,
    optionType,
    productType,
    setProductType,
    handleGetJewellery,
  } = useOrderContext();

  const configurationValue = useFormik({
    enableReinitialize: true,
    initialValues: {
      productId: jewellery?._id,
      userId: user?._id, // assuming this is user ID
      type: "jewellery",
      configuration: {
        metal: {
          type: selectedMetal,
          carateType: selectedKarat,
        },
        ringSize: ringSize, // optional, only for rings
        diamond: {
          shape: jewellery?.shape,
          carat: selectedSize,
        },
        braceletLength: braceletLength, // optional, only for bracelets
      },
    },
    validationSchema: Yup.object({
      metal: Yup.object({
        type: Yup.string().required("Metal type is required"),
        carateType: Yup.string().required("Carat type is required"),
      }),
      diamond: Yup.object({
        shape: Yup.string().required("Diamond shape is required"),
        carat: configuration?.showStoneSize
          ? Yup.number()
              .typeError("Carat must be a number")
              .required("Carat is required")
          : Yup.number().typeError("Carat must be a number").nullable(),
      }),
      ...(configuration?.showRingSize && {
        ringSize: Yup.number()
          .typeError("Ring size must be a number")
          .required("Ring size is required"),
      }),
      ...(configuration?.showBraceletLength && {
        braceletLength: Yup.number()
          .typeError("Bracelet length must be a number")
          .required("Bracelet length is required"),
      }),
    }),
    onSubmit: (values) => {
      console.log("Submitted config values:", values);
    },
  });

  // useEffect(() => {
  //   getDiamondPrice(1);
  // }, [jewellery]);

  useEffect(() => {
    // Check if jewellery data is available and if the category has ring size enabled
    if (jewellery && jewellery.category) {
      const category = categories.find(
        (cat: any) => cat.name === jewellery.category
      );
      setConfiguration(category);
    }
  }, [jewellery, categories]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    configurationValue.setFieldValue(name, value);

    // onAddressChange({ ...addAddressValue.values, [name]: value }); // Call the function to update address
  };
  

  return (
    <div>
      <div className="card p-5">
        <div className="pb-4 pb-2 text-[16px] font-semibold">
          Product Details
        </div>
        <hr />
        {!jewellery && (
          <div
            className={`pt-5 ${
              !selectedType ? "flex items-end gap-x-3" : ""
            }`}
          >
            <div
              className={`flex-1 ${
                !selectedType ? "" : "grid grid-cols-1 gap-5 lg:grid-cols-2"
              }`}
            >
              <div className="">
                <label
                  htmlFor="select-field"
                  className="inline-block mb-2 text-base font-medium"
                >
                  Select Type
                </label>
                <Select
                  inputId="select-field"
                  className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  options={optionType}
                  value={optionType.find((opt) => opt.value === selectedType)}
                  onChange={(option) => {
                    setSelectedType(option?.value || "");
                    setProductType(""); // reset input when changing dropdown
                  }}
                  // placeholder="Select Sku, Slug or ID"
                />
              </div>
              {selectedType && (
                <div className="">
                  <label
                    htmlFor="input-field"
                    className="inline-block mb-2 text-base font-medium capitalize"
                  >
                    Enter {selectedType}
                  </label>
                  <input
                    id="input-field"
                    type="text"
                    value={productType}
                    onChange={(e) => setProductType(e.target.value)}
                    className="w-full border border-slate-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-custom-500 dark:bg-zink-700 dark:border-zink-600 dark:text-zink-100"
                    placeholder={`Enter ${selectedType}`}
                  />
                </div>
              )}
            </div>
            <div className={`flex justify-end ${selectedType ? "pt-5" : ""}`}>
              <button
                type="button"
                onClick={handleGetJewellery}
                className="h-[35px] px-4 whitespace-nowrap bg-custom-500 text-white rounded hover:bg-custom-600"
              >
                Get Details
              </button>
            </div>
            {/* <label
              htmlFor="productNameInput"
              className="inline-block mb-2 text-base font-medium"
            >
              Product Id
            </label>
            <div className="flex gap-x-3 items-center">
              <input
                type="text"
                id="productNameInput"
                className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                placeholder="Product id"
                name="title"
                value={productDetail}
                onChange={(e) => setProductDetail(e.target.value)}
              />
              <button
                type="button"
                onClick={handleGetJewellery}
                className="h-[35px] px-4 whitespace-nowrap bg-custom-500 text-white rounded hover:bg-custom-600"
              >
                Get Details
              </button>
            </div> */}
            {generateOrderValue.errors.productId &&
              generateOrderValue.touched.productId && (
                <div className="text-red-500 text-sm mt-1">
                  {generateOrderValue.errors.productId}
                </div>
              )}
          </div>
        )}
        {/* {isLoading ? (
          <div className="relative flex items-center justify-center min-h-full">
            <div className="flex justify-center fixed top-[50%]">
              <Loader2 className="size-[35px] ltr:mr-2 rtl:ml-2 animate-spin" />
            </div>
          </div>
        ) : ( */}
        <div>
          {jewellery && (
            <div>
              <div className={`border rounded`}>
                <p className="text-base flex gap-x-4 items-center text-slate-800">
                  <img
                    className="size-20"
                    src={jewellery.media[0]?.images[0] || ""}
                  />
                  <div>
                    <p> {jewellery.title}</p>
                    <p className="text-[15px] font-semibold">{`$ ${
                      isLoadingPrice
                        ? "Loading..."
                        : totalJewelleryPrice?.priceWithoutDiscount
                    }`}</p>
                  </div>
                </p>
              </div>
              <form onSubmit={configurationValue.handleSubmit}>
                <div className="mt-4">
                  {configuration?.showRingSize && (
                    <div>
                      <label
                        htmlFor={`ringSize`}
                        className="inline-block mb-2 text-base font-medium"
                      >
                        Ring Size
                      </label>
                      <Select
                        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        options={ringSizeOptions}
                        id={`ringSize`}
                        placeholder={`Select Ring size`}
                        value={ringSizeOptions.find(
                          (option: any) =>
                            option.value ===
                            configurationValue.values.configuration.ringSize
                        )}
                        onChange={(selected) => {
                          setRingSize(selected?.value);
                          configurationValue.setFieldValue(
                            "configuration.ringSize",
                            selected?.value
                          );
                          generateOrderValue.setFieldValue(
                            "configuration.ringSize",
                            selected?.value
                          );
                        }}
                      />
                      {generateOrderValue.touched.configuration?.ringSize &&
                        generateOrderValue.errors.configuration?.ringSize && (
                          <p className="text-red-500 text-sm mt-1">
                            {generateOrderValue.errors.configuration.ringSize}
                          </p>
                        )}
                    </div>
                  )}
                  {configuration?.showStoneSize && (
                    <div className="pt-3">
                      <label
                        htmlFor={`stoneSize`}
                        className="mb-2 inline-block text-base font-medium"
                      >
                        Stone Size
                      </label>
                      <div className="flex gap-x-2">
                        {stoneSizes.map((stoneSize: any, index: number) => (
                          <button
                            key={index}
                            type="button"
                            onClick={() => {
                              // getDiamondPrice(stoneSize.value);
                              setSelectedSize(stoneSize.value);
                              configurationValue.setFieldValue(
                                "configuration.diamond",
                                {
                                  carat: stoneSize.value,
                                  shape: jewellery?.shape,
                                }
                              );
                              generateOrderValue.setFieldValue(
                                "configuration.diamond",
                                {
                                  carat: stoneSize.value,
                                  shape: jewellery?.shape,
                                }
                              );
                            }}
                            className={`px-2.5 py-1 text-xs w-fit font-medium rounded border bg-white text-slate-500 border-slate-400 dark:bg-zink-700 dark:text-zink-200
                                    ${
                                      selectedSize === stoneSize.value
                                        ? "border-slate-800 text-slate-800 dark:border-zink-500"
                                        : ""
                                    }
                                  `}
                          >
                            {stoneSize.label}
                          </button>
                        ))}
                      </div>
                      {configurationValue.touched.configuration?.diamond
                        ?.carat &&
                        configurationValue.errors.configuration?.diamond
                          ?.carat && (
                          <p className="text-red-500 text-sm mt-1">
                            {
                              configurationValue.errors.configuration.diamond
                                .carat
                            }
                          </p>
                        )}
                    </div>
                  )}
                  {configuration?.showBraceletLength && (
                    <div>
                      <label
                        htmlFor={`braceletLength`}
                        className="inline-block mb-2 text-base font-medium"
                      >
                        Bracelet Length
                      </label>
                      <Select
                        className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                        options={braceletLengthOption}
                        id={`braceletLength`}
                        placeholder={`Select Bracelet Length`}
                        value={braceletLengthOption.find(
                          (option: any) =>
                            option.value ===
                            configurationValue.values.configuration
                              .braceletLength
                        )}
                        onChange={(selectedOption) => {
                          setBraceletLength(selectedOption?.value);
                          configurationValue.setFieldValue(
                            "configuration.braceletLength",
                            selectedOption?.value || ""
                          );
                          generateOrderValue.setFieldValue(
                            "configuration.braceletLength",
                            selectedOption?.value || ""
                          );
                        }}
                      />
                      {configurationValue.touched.configuration
                        ?.braceletLength &&
                        configurationValue.errors.configuration
                          ?.braceletLength && (
                          <p className="text-red-500 text-sm mt-1">
                            {
                              configurationValue.errors.configuration
                                .braceletLength
                            }
                          </p>
                        )}
                    </div>
                  )}
                  <div className="pt-3">
                    <label
                      htmlFor={`braceletLength`}
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Select Metal
                    </label>
                    <div className="flex flex-wrap items-center gap-2">
                      <div>
                        <input
                          id="select-metal-yellowgold-14k"
                          className="hidden peer"
                          type="radio"
                          value="yellowgold"
                          name="selectMetal"
                          onChange={() => {
                            handleSelectionChange("yellowgold", "14k");
                          }}
                        />
                        <label
                          htmlFor="select-metal-yellowgold-14k"
                          className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer"
                          style={{
                            border:
                              selectedMetal === "yellowgold" &&
                              selectedKarat === "14k"
                                ? "2px solid #e6cd92"
                                : "",
                            background:
                              "linear-gradient(225deg, #e6cd92, hsla(42,63%,74%,0.1) 50%, #e6cd92)",
                          }}
                        >
                          14K
                        </label>
                      </div>
                      <div>
                        <input
                          id="select-metal-rosegold-14k"
                          className="hidden peer "
                          type="radio"
                          value="rosegold"
                          name="selectMetal"
                          onChange={() => {
                            handleSelectionChange("rosegold", "14k");
                          }}
                        />
                        <label
                          htmlFor="select-metal-rosegold-14k"
                          className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer"
                          style={{
                            border:
                              selectedMetal === "rosegold" &&
                              selectedKarat === "14k"
                                ? "2px solid #e7b395"
                                : "",
                            background:
                              "#fff linear-gradient(225deg,#e7b395,hsla(22,63%,75%,.1) 50%, #e7b395)",
                          }}
                        >
                          14K
                        </label>
                      </div>
                      <div>
                        <input
                          id="select-metal-whitegold-14k"
                          className="hidden peer "
                          type="radio"
                          value="whitegold"
                          name="selectMetal"
                          onChange={() => {
                            handleSelectionChange("whitegold", "14k");
                          }}
                        />
                        <label
                          htmlFor="select-metal-whitegold-14k"
                          className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer"
                          style={{
                            border:
                              selectedMetal === "whitegold" &&
                              selectedKarat === "14k"
                                ? "2px solid #cececc"
                                : "",
                            background:
                              "#fff linear-gradient(225deg,#cececc,hsla(0,0%,85%,.1) 50%, #cececc)",
                          }}
                        >
                          14K
                        </label>
                      </div>
                      <div>
                        <input
                          id="select-metal-yellowgold-18k"
                          className="hidden peer"
                          type="radio"
                          value="yellowgold"
                          name="selectMetal"
                          defaultChecked
                          onChange={() => {
                            handleSelectionChange("yellowgold", "18k");
                          }}
                        />
                        <label
                          htmlFor="select-metal-yellowgold-18k"
                          className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer"
                          style={{
                            border:
                              selectedMetal === "yellowgold" &&
                              selectedKarat === "18k"
                                ? "2px solid #e6cd92"
                                : "",
                            background:
                              "linear-gradient(225deg, #e6cd92, hsla(42,63%,74%,0.1) 50%, #e6cd92)",
                          }}
                        >
                          18K
                        </label>
                      </div>
                      <div>
                        <input
                          id="select-metal-rosegold-18k"
                          className="hidden peer "
                          type="radio"
                          value="rosegold"
                          name="selectMetal"
                          onChange={() =>
                            handleSelectionChange("rosegold", "18k")
                          }
                        />
                        <label
                          htmlFor="select-metal-rosegold-18k"
                          className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer"
                          style={{
                            border:
                              selectedMetal === "rosegold" &&
                              selectedKarat === "18k"
                                ? "2px solid #e7b395"
                                : "",
                            background:
                              "#fff linear-gradient(225deg,#e7b395,hsla(22,63%,75%,.1) 50%,#e7b395)",
                          }}
                        >
                          18K
                        </label>
                      </div>
                      <div>
                        <input
                          id="select-metal-whitegold-18k"
                          className="hidden peer "
                          type="radio"
                          value="whitegold"
                          name="selectMetal"
                          onChange={() =>
                            handleSelectionChange("whitegold", "18k")
                          }
                        />
                        <label
                          htmlFor="select-metal-whitegold-18k"
                          className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer"
                          style={{
                            border:
                              selectedMetal === "whitegold" &&
                              selectedKarat === "18k"
                                ? "2px solid #cececc"
                                : "",
                            background:
                              "#fff linear-gradient(225deg,#cececc,hsla(0,0%,85%,.1) 50%,#cececc)",
                          }}
                        >
                          18K
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default ProductDetail;
